import { Alert } from "@/models/alert";
import { Pagination } from "@/models/pagination";
import { IAlert, AlertState } from "@/types/alert";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<AlertState, IAlert> = {
  single: (state, single) => {
    state.single = new Alert(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Alert(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Alert();
    state.pagination = new Pagination();
  },
};

export default mutations;
